import { useState } from 'react';

import type {
  FieldValues,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form';

import { useHttpHandleError, type HttpError } from './useHttpHandleError';

export const useManageSubmit = <T extends FieldValues>(
  form: UseFormReturn<T>,
) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleError = useHttpHandleError(form.setError);

  const handleSubmit = (onValid: SubmitHandler<T>) => {
    // override the form.handleSubmit to display server errors
    return form.handleSubmit(async (data) => {
      try {
        setIsSubmitting(true);
        await onValid(data);
      } catch (error) {
        handleError(error as HttpError);
      } finally {
        setIsSubmitting(false);
      }
    });
  };

  return { handleSubmit, isSubmitting };
};
